/* 合法设备组 */
export function checkDvcGroup(str){
  const reg = /^[\u4E00-\u9FA5a-zA-Z0-9\-]{1,10}$/;

  return reg.test(str.trim());
}
/* 是否邮箱*/
export function isEmail(str) {
  //debugger
  const reg = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/;
  return reg.test(str.trim());
}

/* 是否手机号*/
export function isTelPhone(str) {
  const reg = /^[0-9_-]{0,15}$/;
  return reg.test(str.trim());
}

/* 合法用户名( 账号 ) */
export function validateUsername(str){
  const reg = /^[a-zA-Z][a-zA-Z0-9_-]{4,19}$/;
  // const reg_email = /^([.a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
  // const reg_tel = /^[0-9_-]{0,15}$/;
  return reg.test(str.trim());// ||reg_email.test(str.trim())||reg_tel.test(str.trim());
}

/* 合法昵称( 姓名 ) */
export function validateNickname(str){
    const reg = /^[\u4E00-\u9FA5a-zA-Z0-9_\-]{1,10}$/;

    return reg.test(str.trim());
}

/**
 * 合法设备编号
 */
export function validateTusn(str){
  const reg = /^[a-zA-Z0-9_-]{1,30}$/;
  return reg.test(str.trim());
}

/**
 * 合法用户密码
 */
export function validatePass(str){
  const reg = /^(?=.*[a-zA-Z])(?=.*\d).{6,16}$/;
  return reg.test(str.trim());
}


/**
 * 用户密码规则一（至少6位，且含字母及数字）
 */
export function validatePass1(str){
  const reg = /^(?=.*[a-zA-Z])(?=.*\d).{6,}$/;
  return reg.test(str.trim());
}



/**
 * 用户密码规则二（无重复字母或数字）
 */
// export function validatePass2(str){
//   // const reg = /^(?!.*([A-Za-z0-9])\1{4})(?=.*[a-zA-Z])(?=.*\d)$/;
//   const reg = /^[1-9a-zA-Z]{5}$/;
//   return reg.test(str.trim());
// }

export function validatePass2(str){
  var obj=[];
  for(var i = 0; i< str.length; i++){
    var key = str[i];
    if(!obj[key]){
      obj[key] = 1;
    }else{
      obj[key] ++;
    }
  }
  var max = -1;
  var max_key = '';
  var key;
  for(key in obj){
    if(max<obj[key]){
      max=obj[key];
      max_key = key;
    }
  }
  console.log(max_key+"为最多出现字符，出现的次数为"+max);
  if(max>4){
    return false;
  }else {
    return  true;
  }
}



/**
 * 用户密码规则三（无连续数字）
 */
export function validatePass3(str){
  var count = 0;

  for(var i =0;i<str.length;i++){
    if(parseInt(str[i])){
      for(var j=i;j<str.length-4;j++){
        if(str[j+1]-str[j]==1 && str[j+2]-str[j+1]==1  && str[j+3]-str[j+2]==1  && str[j+4]-str[j+3]==1){
          count++;
        }
        if(str[j+1]-str[j]==-1 && str[j+2]-str[j+1]==-1  && str[j+3]-str[j+2]==-1  && str[j+4]-str[j+3]==-1){
          count++;
        }
      }
    }else {
      continue;
    }
  }
  if(count>0){
    return false;
  }else {
    return  true;
  }

}


/**
 * 合法imei
 */
export function validateImei(str){
  const reg = /^[a-zA-Z0-9_-]{1,20}$/;
  return reg.test(str.trim());
}

/* 合法机构编号 */
export function validateNodeCode(str){
  const reg = /^[a-zA-Z0-9_-]{1,20}$/;
  return reg.test(str.trim());
}

/* 合法机构名称 */
export function validateNodeName(str){
  const reg = /^[\u4e00-\u9fa5a-zA-Z0-9.\s@_-]{1,30}$/;
  return reg.test(str.trim());
}

/**
 * 合法机构别名
 */
export function validateNodeAliasName(str){
  const reg = /^[\u4e00-\u9fa5a-zA-Z0-9\s]{0,10}$/;
  return reg.test(str.trim());
}

/**
 * 描述
 */
export function validateDesc(str){
  const reg = /^[\u4e00-\u9fa5a-zA-Z0-9_-\s]{0,200}$/;
  return reg.test(str.trim());
}

/* 合法机构地址 */
export function validateAddress(str){
  const reg = /^[\u4e00-\u9fa5a-zA-Z0-9\s]{1,100}$/;
  return reg.test(str.trim());
}

/*合法策略名称*/
export function validateStrategy(str){
  const reg = /^[\u4E00-\u9FA5A-Za-z0-9\-]{1,15}$/;
  return reg.test(str.trim());
}

/*合法包名*/
export function validatePackage(str){
  const reg = /^[a-zA-Z0-9_]{0,60}[a-zA-Z0-9._]{0,60}[a-zA-Z0-9_]$/;
  return reg.test(str.trim());
}

/*合法网址*/

export function validateWebsite(str){
  const reg = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\*\+,;=.]+$/;
  return reg.test(str.trim());
}
/*正整数*/
export function validatePositiveInt(str){
  const reg = /^[1-9]\d*$/;
  return reg.test(str.trim());
}



// WEBPACK FOOTER //
// ./src/common/utils/validate.js